import axios from "axios";

const baseApiUrl =
  process.env.REACT_APP_API_LOGIN_URL ||
  "https://api-dev-scoringcapture.lanetalk.com/v1";

// Create an Axios instance
const AxiosInstance = axios.create({
  baseURL: `${baseApiUrl}`,
});

// Function to set the default authorization header
export const setAuthorizationHeader = (token) => {
  if (token) {
    AxiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete AxiosInstance.defaults.headers.common["Authorization"];
  }
};

export default AxiosInstance;
